import styled from "styled-components";
import CSS from 'csstype';

interface FlexContainerProps {
    isInline?: boolean,
    flexDirection?: CSS.Property.FlexDirection
    alignItems?: CSS.Property.AlignItems
    justifyContent?: CSS.Property.JustifyContent
    gap?: number,
    flexWrap?: CSS.Property.FlexWrap,
    flex?: CSS.Property.Flex
}

const FlexContainer = styled.div<FlexContainerProps>`
  display: ${props => props.isInline ? "inline-flex" : "flex"};
  flex-direction: ${props => props.flexDirection ?? "row"};
  align-items: ${props => props.alignItems ?? "center"};
  justify-content: ${props => props.justifyContent ?? "center"};
  gap: ${props => props.gap ? `${props.gap}px` : "0"};
  flex-wrap: ${props => props.flexWrap ?? "nowrap"};
  flex: ${props => props.flex};
  position: relative;


`

export default FlexContainer